import React from 'react';
import i18n from 'i18next';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';
import ReplayIcon from '@material-ui/icons/Replay';

function UgcReuploadBtn({ style, onClick = () => {}, componentStyle }) {
    return (
        <button css={[btnStyle, css(style)]} onClick={onClick}>
            <ReplayIcon css={iconStyle(componentStyle)} />
            <Typography variant="button" css={labelStyle(componentStyle)}>
                {i18n.t('btn.reupload')}
            </Typography>
        </button>
    );
}

export default UgcReuploadBtn;

const btnStyle = css`
    display: flex;
    cursor: pointer;
    text-decoration: none;
    color: #000000;
    background-color: transparent;
    border: none;
`;
const labelStyle = (componentStyle = {}) => css`
    font-weight: 500;
    color: ${componentStyle.titleColor};
    word-break: break-all;
    margin-left: 13px;
`;
const iconStyle = (componentStyle = {}) => css`
    color: ${componentStyle.titleColor};
`;
